import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getAgreementsAction } from '@/shared/store/agreements/actions';
import { ROLE } from '@/shared/api/borrow';

export const useRefreshAgreements = (role: ROLE) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(
            getAgreementsAction({
                role,
                withoutCache: true,
            }),
        );
    }, [dispatch, role]);
};
